<div mat-dialog-content>
  <lemon-dialog-header> Kirjanpitoaineiston latauslinkki </lemon-dialog-header>

  <div>Kirjanpitoaineisto voidaan ladata alla olevasta linkistä yhden viikon ajan:</div>
  <div style="margin: 1em; color: gray">
    {{ url }}
  </div>
  <app-secondary-button (click)="toClipboard()" actionId="Kopioi kirjanpidon aineiston lataus url"> Kopioi leikepöydälle napauttamalla tätä </app-secondary-button>
</div>
<div mat-dialog-actions style="padding-left: 0; padding-right: 0">
  <app-primary-button mat-dialog-close actionId="Latauslinkki / Kopioi leikepöydälle (dialog)">OK</app-primary-button>
</div>
